module.exports = __webpack_public_path__ + "static/Max3-7faf4b4052677abf9193039cb18abb74.jpg";